import { render, staticRenderFns } from "./CustomerDocuments.vue?vue&type=template&id=4e38a1ff&scoped=true&"
import script from "./CustomerDocuments.vue?vue&type=script&lang=ts&"
export * from "./CustomerDocuments.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerDocuments.vue?vue&type=style&index=0&id=4e38a1ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e38a1ff",
  null
  
)

export default component.exports